export default {"src":"/_next/static/media/handball.e4341d37.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};